module.exports = __webpack_public_path__ + "static/media/27OCHA20.37f6b63f.jpg";